/**
 * Quick View — Fetches product section and opens in modal
 */
(function () {
  'use strict';

  /* Create modal element once */
  const modal = document.createElement('div');
  modal.className = 'quick-view-modal';
  modal.innerHTML = `
    <div class="quick-view-modal__overlay" data-qv-overlay></div>
    <div class="quick-view-modal__container">
      <button class="quick-view-modal__close" data-qv-close aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <div class="quick-view-modal__body" data-qv-body>
        <div class="quick-view-modal__loading">
          <span class="loading-spinner"></span>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const body = modal.querySelector('[data-qv-body]');
  const overlay = modal.querySelector('[data-qv-overlay]');
  const closeBtn = modal.querySelector('[data-qv-close]');

  const cache = {}; /* intentionally not caching to always get fresh scripts */

  function open(handle) {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    /* Show loading */
    body.innerHTML =
      '<div class="quick-view-modal__loading"><span class="loading-spinner"></span></div>';

    /* Fetch or use cache */
    const fetchContent = cache[handle]
      ? Promise.resolve(cache[handle])
      : fetch(`/products/${handle}?section_id=quick-view-content`)
          .then((res) => res.text())
          .then((html) => {
            cache[handle] = html;
            return html;
          });

    fetchContent
      .then((html) => {
        body.innerHTML = html;

        /* Execute inline scripts (innerHTML doesn't run them) */
        body.querySelectorAll('script').forEach((oldScript) => {
          const newScript = document.createElement('script');
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        /* Re-initialize variant picker if present */
        const vp = body.querySelector('variant-picker');
        if (vp && !vp._initialized) {
          vp.connectedCallback && vp.connectedCallback();
          vp._initialized = true;
        }

        /* Re-initialize product form if present */
        const pf = body.querySelector('product-form');
        if (pf && !pf._initialized) {
          pf.connectedCallback && pf.connectedCallback();
          pf._initialized = true;
        }
      })
      .catch(() => {
        body.innerHTML =
          '<div class="quick-view-modal__loading"><p>Failed to load product</p></div>';
      });
  }

  function close() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Event listeners */
  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      close();
    }
  });

  /* Delegate click to quick view triggers */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-view-trigger]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = trigger.dataset.quickViewTrigger;
    if (handle) open(handle);
  });

  /* Close quick view when item is added to cart */
  SixSeven.on(SixSeven.Events.CART_ITEM_ADDED, close);
})();
